export type LineIconProps = {
  width: string | number;
  height: string | number;
};

const LineIcon = ({ width, height }: LineIconProps) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 33 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Frame" clipPath="url(#clip0_2095_267546)">
          <rect
            id="Rectangle 1"
            x="5.83594"
            y="6.66699"
            width="21.3333"
            height="13.3333"
            fill="white"
          />
          <g id="Group">
            <path
              id="Vector"
              d="M32.4279 12.3459L32.4106 12.2572L32.3761 11.9379C32.3761 11.867 32.3588 11.796 32.3588 11.7251V11.6541H32.3415C31.9441 9.36585 30.8728 7.21951 29.2141 5.35698C27.5554 3.51219 25.4128 2.07539 23.0111 1.15299C20.9376 0.390244 18.7433 0 16.4798 0C13.4387 0 10.4841 0.727273 7.92684 2.1286C3.00243 4.8071 0.1169 9.73836 0.531587 14.6874C0.756209 17.2417 1.72381 19.6896 3.36528 21.7295C4.90308 23.663 6.97651 25.2239 9.36096 26.235C10.8296 26.8559 12.281 27.1574 13.8188 27.459L13.9916 27.4945C14.4063 27.5831 14.5273 27.7073 14.5618 27.7428C14.6137 27.8315 14.5791 28.0089 14.5618 28.0976C14.5445 28.204 14.5273 28.2927 14.51 28.3814C14.3372 29.0732 14.1817 29.7827 14.3026 30.5809C14.4582 31.4856 15.0111 32 15.8059 32C16.6698 32 17.6547 31.3969 18.3113 31.0067L18.3977 30.9534C19.9528 30.0133 21.4214 28.949 22.5273 28.133C24.9463 26.3415 27.6763 24.3193 29.7325 21.694C31.8232 19.051 32.7908 15.6452 32.4279 12.3459ZM10.4668 17.3659H7.70221C7.28753 17.3659 6.94195 17.0111 6.94195 16.5854V10.643C6.94195 10.2173 7.28753 9.86253 7.70221 9.86253C8.1169 9.86253 8.46247 10.2173 8.46247 10.643V15.8226H10.4668C10.8815 15.8226 11.2271 16.1774 11.2271 16.6031C11.2271 17.0111 10.8815 17.3659 10.4668 17.3659ZM13.3523 16.5676C13.3523 16.9933 13.0068 17.3481 12.5921 17.3481C12.1774 17.3481 11.8318 16.9933 11.8318 16.5676V10.6075C11.8318 10.1818 12.1774 9.82705 12.5921 9.82705C13.0068 9.82705 13.3523 10.1818 13.3523 10.6075V16.5676ZM20.1774 16.5676C20.1774 16.9047 19.97 17.2062 19.659 17.3126C19.5726 17.3304 19.5035 17.3481 19.4171 17.3481C19.1752 17.3481 18.9506 17.2417 18.8124 17.0288L16.0823 13.1796V16.5676C16.0823 16.9933 15.7368 17.3481 15.3221 17.3481C14.9074 17.3481 14.5618 16.9933 14.5618 16.5676V10.7849C14.5618 10.4479 14.7692 10.1463 15.0802 10.0399C15.3912 9.93348 15.7368 10.0576 15.9268 10.3237L18.6396 14.1729V10.6075C18.6396 10.1818 18.9852 9.82705 19.3998 9.82705C19.8145 9.82705 20.1601 10.1818 20.1601 10.6075V16.5676H20.1774ZM25.672 17.2239H21.9398C21.5251 17.2239 21.1795 16.8692 21.1795 16.4435V13.4634V10.4834C21.1795 10.0576 21.5251 9.70288 21.9398 9.70288H25.5683C25.983 9.70288 26.3286 10.0576 26.3286 10.4834C26.3286 10.9091 25.983 11.2639 25.5683 11.2639H22.7001V12.6829H25.0327C25.4474 12.6829 25.7929 13.0377 25.7929 13.4634C25.7929 13.8891 25.4474 14.2439 25.0327 14.2439H22.7001V15.663H25.6893C26.1039 15.663 26.4495 16.0177 26.4495 16.4435C26.4495 16.8692 26.1039 17.2239 25.672 17.2239Z"
              fill="currentColor"
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_2095_267546">
            <rect
              width="32"
              height="32"
              fill="white"
              transform="translate(0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

export default LineIcon;
